/**
 * Custom-name (engraving) rules for the Insole Design section.
 *
 * Names of the Prophet (peace be upon him) — Ahmed / Mohammed / Mohamed — are
 * not engraved on insoles out of respect. This is an INFORMATIVE warning only;
 * it never blocks submission. The match is case-insensitive and whole-word,
 * anywhere in the value, so "mohamed ali" and "Ahmed" both flag while a longer
 * token that merely contains the letters (e.g. "Mohammedan") does not.
 */
export const PROPHET_NAME_RE = /\b(?:ahmed|mohammed|mohamed)\b/i;

export const PROPHET_NAME_WARNING =
  'Out of respect, this name will not be engraved on the insole, as it is a name of the Prophet.';

/** True when the custom name contains a name of the Prophet as a whole word. */
export function isProphetName(value: string | null | undefined): boolean {
  return PROPHET_NAME_RE.test(value ?? '');
}
